import { render, staticRenderFns } from "./configureProfile.vue?vue&type=template&id=e8a2675c&scoped=true"
import script from "./configureProfile.vue?vue&type=script&lang=js"
export * from "./configureProfile.vue?vue&type=script&lang=js"
import style0 from "./configureProfile.vue?vue&type=style&index=0&id=e8a2675c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a2675c",
  null
  
)

export default component.exports